/** Display name for CRM contact: firstName + lastName, never fullName */
export function getContactDisplayName(
  contact: { firstName?: string | null; lastName?: string | null } | null | undefined
): string {
  if (!contact) return 'ללא שם';
  const name = `${contact.firstName ?? ''} ${contact.lastName ?? ''}`.trim();
  return name || 'ללא שם';
}
